import { teApi } from 'yxt-biz-pc/packages/api';

// 预约详情
export const getSubscribeDetail = (query) => {
  return teApi.get('/appt/target/teacher/detail', query);
};
